/** Maps mock/API trigger reason strings to watchList i18n keys. */
export const WATCH_LIST_TRIGGER_REASON_KEYS: Record<string, string> = {
  'Cash deposit': 'triggers.cashDeposit',
  'Ext. transfer': 'triggers.extTransfer',
  'Sector concentration': 'triggers.sectorConcentration',
  'Dividend reinvestment': 'triggers.dividendReinvestment',
};
